import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography, IconButton } from '@material-ui/core';

import { IValidationField } from '../../../../services/ContentValidator/interfaces/validation.interface';
import ImageSpoiler from '../../../ImageSpoiler/ImageSpoiler';
import { IErrorDetailsData } from '../../interfaces/detailsData.interface';
import useStyles from './styles';

interface IAnalysisRowProps {
  error: IValidationField
  icon: IconProp;
  iconColor: string;
  extraClassNames?: string[];
  onOpenDetails?: (details: IErrorDetailsData) => void;
  category?: string;
}

const AnalysisRow: React.FC<IAnalysisRowProps> = ({ error, icon, iconColor, extraClassNames, onOpenDetails, category }) => {
  const classes = useStyles();

  const handleOpenDetails = () => {
    // eslint-disable-next-line no-unused-expressions
    onOpenDetails?.({
      details: error.details || [],
      message: error.message,
    });
  };

  return (
    <Box className={classes.container}>
      <Box display="flex" flexDirection="row" alignItems="center">
        <FontAwesomeIcon className={clsx(classes.icon, ...(extraClassNames || []))} color={iconColor} icon={icon} />
        <Box className={classes.errorTextContainer}>
          <Typography className={classes.errorText}>{ReactHtmlParser(error.message)}</Typography>
          {category && <Typography component="span" className={classes.category}>{category}</Typography>}
        </Box>
        {
          error.link && (
            <IconButton target="_blank" href={error.link}>
              <FontAwesomeIcon className={classes.linkIcon} icon="external-link-alt" />
            </IconButton>
          )
        }
        {
          error.details && (
            <Box className={classes.detailsButtonContainer}>
              <Button onClick={handleOpenDetails} fullWidth className={classes.detailsButton}>
                <FontAwesomeIcon icon="arrow-right" />
              </Button>
            </Box>
          )
        }
      </Box>
      {
        // eslint-disable-next-line react/jsx-key
        error.images?.map((image) => <ImageSpoiler image={image} />)
      }
    </Box>
  );
};

export default AnalysisRow;
